export default "__VITE_ASSET__yudoMIPB__"